const localPorts = require('../../localPorts.config').localPorts;
const local = require('../../config/local');

module.exports = {
  API: `http://localhost:${localPorts.inyonwhitney}/api`,
  CDN: `http://localhost:${localPorts.inyonwhitney}`,
  DRUPAL_API: 'http://localhost:8080/jsonapi', // DrupalService
  MAPBOX_ACCESS_TOKEN: local.MAPBOX_ACCESS_TOKEN,
  MAPBOX_STYLE: local.MAPBOX_STYLE,
  NODE_ENV: 'development',
  REACT_AXE_ENABLED: false,
  SENTRY_CONFIG_URL: 'https://551530989e934bceacf37321c9d8bb9c@sentry.io/1137789'
};
